
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-quote-block--default--layout-gap:var(--spacing-08);
  --sic-quote-block--default--outer-padding:clamp(
    var(--spacing-10),
    calc(0.5rem + 3.75vw),
    var(--spacing-20)
  );
  --sic-quote-block--default--content-padding-sides:clamp(
    var(--spacing-05),
    calc(-1.3125rem + 6.09375vw),
    var(--spacing-24)
  );
  --sic-quote-block--default--content-padding-block:clamp(
    var(--spacing-03),
    calc(1rem + 5vw),
    var(--spacing-20)
  );
  --sic-quote-block--default--content-padding-block--with-image:clamp(
    var(--spacing-08),
    calc(-2.6666rem + 9.722vw),
    9rem
  );
  --sic-quote-block--default--content-font-size:var(--body-02-font-size);
  --sic-quote-block--default--content-line-height:var(--body-02-line-height);
  --sic-quote-block--default--content-spacing:var(--spacing-04);
  --sic-quote-block--default--icon-size:clamp(
    var(--spacing-16),
    calc(-2rem + 9vw),
    var(--spacing-32)
  );
}
`;